export default __webpack_public_path__ + "static/media/notificationBell.bed71573.svg";